import styled from "styled-components";

/**
 * ログイン画面のスタイルコンポーネント (Seller用)
 * @@@ コメントアウト確認
 * 部品を売る → 会員様ログイン
 * 部品を売る/車輌を買う → 会員様ログイン
 */
const LoginStyles = {
  // ログインコンテナ
  LoginContainer: styled.div`
    //min-height: 100vh;
    background: #000 url("/images/header_bg.jpg") 50% 0 no-repeat;
    font-family: "ヒラギノ角ゴ Pro W3", "Hiragino Kaku Gothic Pro", "メイリオ", Meiryo, Osaka, "ＭＳ Ｐゴシック", "MS PGothic", sans-serif;
    position: relative;
    padding-bottom: 0px;
  `,

  // ボディ背景
  BodyBackground: styled.div`
    /* background: url("/images/bg.png") 0 0; */
    min-height: 100vh;
    display: flex;
    flex-direction: column;
  `,

  // ヘッダー
  Header: styled.div`
    height: 500px;
    width: 100%;
    /* background: #999 url("/images/header_bg.png") no-repeat 50%; */
  `,

  // コンテナ
  Container: styled.div`
    width: 1000px;
    margin: 0 auto;
    height: 440px;
  `,

  // ロゴ
  Logo: styled.div`
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
    margin: 0 auto;
    height: 60px;
    background-color: rgba(255, 255, 255, 0.5);
    padding: 10px 0px 14px 0px;

    img {
      max-height: 48px;
      margin-left: 8%;
    }
  `,

  // メインエリア
  Main: styled.div`
    display: flex;
    width: 100%;
    height: 380px;
    padding-top: 60px;
  `,

  // ログインボックス
  LoginBox: styled.div`
    float: left;
    width: 50%;
    height: 380px;
    padding-top: 0px;
  `,

  // ログインフォーム
  LoginForm: styled.div`
    background-color: rgba(0, 0, 0, 0.7);
    width: 400px;
    height: 220px;
    margin: 20px auto;
    padding: 10px;
    color: #fff;
    border: 1px solid #ff3333;
  `,

  // ログインタイトル
  LoginTitle: styled.dt`
    font-size: 14px;
    background-color: rgba(255, 51, 51, 0.5);
    padding: 8px 7px;
    /* border-bottom: 1px solid #ff3333; */
  `,

  // ログインコンテンツ
  LoginContent: styled.dd`
    margin: 0;
  `,

  // ログインテーブル
  LoginTable: styled.table`
    margin: 15px 0 0;
    width: 350px;
    margin-left: 20px;

    td,
    th {
      text-align: right;
      padding: 8px 6px;
      font-size: 14px;
    }

    th {
      width: 6em;
      color: #fff;
    }

    label {
      top: -5px;
    }

    input[type="text"] {
      border: 1px solid #FF3333 !important;
	    background: #FFE4E4 !important;
      border-radius: 0 !important;
      width: 250px;
      height: 30px;
      padding: 4px 3px;
      &:-webkit-autofill,
      &:-webkit-autofill:hover,
      &:-webkit-autofill:focus,
      &:-webkit-autofill:active {
        -webkit-box-shadow: 0 0 0 30px #FFE4E4 inset !important;
        -webkit-text-fill-color: #000 !important;
        box-shadow: 0 0 0 30px #FFE4E4 inset !important;
        background: #FFE4E4 !important;
      }
    }

    input[type="password"] {
      border: 1px solid #FF3333 !important;
	    background: #FFE4E4 !important;
      border-radius: 0 !important;
      width: 250px;
      height: 30px;
      padding: 4px 3px;
      &:-webkit-autofill,
      &:-webkit-autofill:hover,
      &:-webkit-autofill:focus,
      &:-webkit-autofill:active {
        -webkit-box-shadow: 0 0 0 30px #FFE4E4 inset !important;
        -webkit-text-fill-color: #000 !important;
        box-shadow: 0 0 0 30px #FFE4E4 inset !important;
        background: #FFE4E4 !important;
      }
    }
  `,

  // 入力フィールド
  Input: styled.input`
    width: 250px;
    height: 22px;
    border: 1px solid #ff3333 !important;
    background: #FFE4E4 !important;
    padding: 2px 5px;
    font-size: 14px;
  `,

  // ログインボタン
  LoginButton: styled.button`
    width: 100px;
    height: 25px;
    color: #fff;
    background: #ff3333;
    border: 1px solid #ff3333;
    margin: auto;
    display: block;
    font-weight: bold;
    font-size: 13px;
    cursor: pointer;

    &:hover {
      background: #e02a2a;
    }

    &:disabled {
      opacity: 0.7;
      cursor: not-allowed;
    }
  `,

  // エラーメッセージ
  ErrorMessage: styled.div`
    color: #c00;
    font-size: 12px;
    text-align: center;
    margin: 0 0 5px;
    padding: 5px;
    background: #ffe4e4;
    border: 1px solid #ff9999;
    border-radius: 3px;
  `,

  // メッセージエリア
  MessageArea: styled.div`
    float: right;
    width: 50%;
    height: 440px;
    margin-top: -17px;
  `,

  // メッセージコンテンツ
  MessageContent: styled.div`
    padding: 0 25px;
    margin: 0 15px;
    height: 200px;
    color: #fff;
    font-size: 14px;
    text-shadow: 0px 0px 3px #000;

    h1 {
      padding: 25px 25px 0;
      display: block;
      border-bottom: 1px solid #fff;
      margin: 10px 0px 0px;
      font-size: 19px;
      font-weight: bold;
      color: #fff;
      text-shadow: 0px 0px 3px #000;
      margin-left: -30px;
    }

    p {
      margin-top: 10px;
    }

    strong {
      font-size: 18px;
      color: #ff0;
    }

    span {
      font-size: 0.9em;
    }

    .emergency {
      display: block;
      margin-top: 1.6em;
    }

    .emergency a {
      display: inline-block;
      height: 20px;
      line-height: 20px;
      margin-left: 50px;
      padding: 0px 10px;
      color: white;
      text-decoration: underline;
    }
  `,

  // ラッパー
  Wrap: styled.div`
    min-height: 100vh;
    display: flex;
    flex-direction: column;
  `,

  // フッター
  Footer: styled.div`
    width: 680px;
    margin: 50px 250px 80px;
    padding: 15px;
    border: 1px solid #ccc;
    background: #fff;
    border-radius: 10px;
    text-align: left;
    color: #333;

    a {
      text-decoration: underline;
      color: blue;
    }

    .contact {
      font-size: 18px;
      font-weight: bold;
      margin-top: 20px;
    }

    strong {
      color: #c00;
      font-size: inherit;
    }

    span {
      font-size: 12px;
      font-weight: normal;
    }
  `,

  // メインコンテンツ
  MainContent: styled.div`
    /* #mainの背景色をコメントアウトして、bodyの背景画像を透かす */
    min-height: 120px;
    padding: 0 0 40px;
    position: relative;
    flex: 1;
  `,

  // フッターコピーライトコンテナ
  FooterCopyrightContainer: styled.div`
    flex-shrink: 0;
    width: 100%;
  `,
};

export default LoginStyles;
